/**
 * Defines reducers related to Primary Navigation bar feature.
 * this reducer will be combined in the store/RootReducer.js
 */

import * as types from 'constants/ActionTypes';
import { isAuthorized, getAuthToken, isShareToken } from 'utils/app.utils';
import { MAX_POLL_TIME, POLL_DURATION } from 'constants/AppConstants';

// One-time read from storage for initial state (same pattern as authorize). #genai
const initialIsShareToken = (() => {
  try {
    return Boolean(isShareToken(getAuthToken()));
  } catch (_) {
    return false;
  }
})();

const initstate = {
  authorize: isAuthorized(),
  isShareToken: initialIsShareToken,
  showToast: false,
  retryCount: 0,
  errorCode: 0,
  errorDescription: '',
  startTimer: true,
  userOnboardStatus: {
    userCreatedInAMP: false,
    userCreatedInLegacy: false,
    isUserFederated: false,
  },
  maxPollTime: MAX_POLL_TIME,
  autoProvisionFlag: false,
  autoProvisionStatus: '',
  showReloadDialog: false,
  isSignOutDisabled: false,
};

export default function (state = initstate, action) {
  const { type } = action;

  switch (type) {
    case types.OKTA_TOKEN_RESPONDED:
      return { ...state, authorize: true };
    case types.OKTA_NEW_TOKEN_FAILURE: {
      const { retryCount, error } = action;
      return {
        ...state, showToast: true, retryCount, errorCode: error.errorCode, errorDescription: error.message,
      };
    }
    case types.RESET_TIMER: {
      const { reset } = action;
      return { ...state, startTimer: reset };
    }
    case types.RESET_RETRY_COUNT:
      return { ...state, retryCount: 0, startTimer: true };
    case types.CLOSE_CONTAINER_TOAST:
      return { ...state, showToast: false };
    case types.SHOW_CONTAINER_TOAST:
      return { ...state, showToast: true, errorDescription: 'jserror' };
    case types.GET_USER_ONBOARDING_STATUS_SUCCESS:
      return {
        ...state,
        userOnboardStatus: action.userStatus,
        maxPollTime: state.maxPollTime - POLL_DURATION,
      };
    case types.SET_AUTOPROVISION:
      return {
        ...state,
        autoProvisionFlag: action.autoProvision,
      };
    case types.AUTO_PROVISION_STATUS:
      return {
        ...state,
        autoProvisionStatus: action.status,
      };
    case types.SET_SHOW_RELOAD_DIALOG:
      return {
        ...state,
        showReloadDialog: action.showReloadDialog,
      };
    case types.SET_SIGN_OUT_DISABLED:
      return {
        ...state,
        isSignOutDisabled: action.payload,
      };
    case types.SET_IS_SHARE_TOKEN:
      return {
        ...state,
        isShareToken: action.payload,
      };
    default:
      return state;
  }
}
